import { call, put } from 'redux-saga/effects';

import generateQuery from 'utils/generateQuery';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';
import { MESSAGES } from 'appconstants';

import {
  REFERRAL,
  LOADING,
  NOTIFICATION,
} from '../actionTypes';

const fetchReferral = async (payload) => {
  const query = generateQuery(payload.currentPage);
  const sorting = payload.sortParams ? payload.sortParams : '&sortBy=createdAt&direction=DESC';
  return axiosAuthInstance.get(`${API_END_POINTS.REFERRAL}${query}${sorting}`);
};

const postReferral = async ({ params }) => axiosAuthInstance.post(API_END_POINTS.REFERRAL, params);

const notificationReferral = async ({ gid, params }) => axiosAuthInstance.patch(`${API_END_POINTS.REFERRAL}/${gid}/notify`, params);

export function* getReferral(action) {
  try {
    const { data: { entity } } = yield call(fetchReferral, action.payload);
    yield put({ type: REFERRAL.SUCCESS, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: REFERRAL.FAILED, payload: e.response.data });
  }
}

export function* addReferral(action) {
  try {
    yield put({ type: LOADING.SUBMITTING });
    yield put({ type: LOADING.VALIDATING });
    yield call(postReferral, action.payload);
    const { data: { entity } } = yield call(fetchReferral, action.payload);
    yield put({ type: REFERRAL.SUCCESS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.REFERRAL.ADD_SUCCESS,
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}

export function* notifyReferral(action) {
  try {
    yield call(notificationReferral, action.payload);
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: `${MESSAGES.REFERRAL.NOTIFY_SUCCESS}${action.payload.name}`,
    });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  }
}
